<template>
    <div>
        <div v-if="$route.path.indexOf('_notify') === -1">
            <div>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <div>
                            <span>ACS待提现余额:¥</span>
                            <span style="font-size:20px">{{ (balance / 100).toFixed(2) }} &emsp;</span>

                            <span>账户集余额:</span>
                            <span> 总额:¥</span>
                            <span style="font-size:20px">{{ (platform.allAmount / 100).toFixed(2) }} &emsp;</span>
                            <span> 冻结额:¥</span>
                            <span style="font-size:20px">{{ (platform.freezeAmount / 100).toFixed(2) }} &emsp;</span>
                            <span>中间账户余额:</span>
                            <span> 总额:¥</span>
                            <span style="font-size:20px">{{ (platform.allAmount2 / 100).toFixed(2) }} &emsp;</span>
                            <span> 冻结额:¥</span>
                            <span style="font-size:20px">{{ (platform.freezeAmount2 / 100).toFixed(2) }} &emsp;</span>

                        </div>
                        <div>
                          <span>营销账户集余额:</span>
                          <span> 总额:¥</span>
                          <span style="font-size:20px">{{ (platform.allAmount3 / 100).toFixed(2) }} &emsp;</span>
                          <span> 冻结额:¥</span>
                          <span style="font-size:20px">{{ (platform.freezeAmount3 / 100).toFixed(2) }} &emsp;</span>
                          <span>收银宝商户资金:¥</span>
                          <span style="font-size:20px">{{ (vps.balance / 100).toFixed(2) }} </span>
                          <small style="color: blue;">(当天账户实时总金额)</small>
                        </div>

                    </div>
                      <div>
                          <el-row>
                            <ul>
                                <li> <span>选择数量: <span style="color:red;">{{ checkNumber.order_total }}</span> </span>
                                    <span>结算数量:
                                        <span style="color:green;">已代付:{{ checkNumber.accounts_success }}</span>
                                        <span style="color:red;">未代付:{{ checkNumber.accounts_fail }}</span>
                                    </span>

                                </li>
                                <li>
                                  <span>订单应付金额: <span style="color:red;">{{ (checkNumber.order_total_fee / 100).toFixed(2)
                                  }}</span> 元
                                  </span>
                               <!--   <span>订单待付金额: <span style="color:red;">{{ (checkNumber.order_total_wait_fee /
                                          100).toFixed(2)
                                  }}</span> 元 </span>

                                  <span>订单已付金额: <span style="color:red;">{{ (checkNumber.order_total_paid_fee /
                                          100).toFixed(2)
                                  }}</span> 元 </span> -->

                                </li>
                                <li>
                                    <span>应付商户: <span style="color:red;">{{ (checkNumber.total_fee / 100).toFixed(2) }}</span> 元
                                    </span>
                                  <!--  <span>待付商户: <span style="color:red;">{{ (checkNumber.merchant_wait_fee / 100).toFixed(2)
                                    }}</span> 元 </span>
                                    <span>已付商户: <span style="color:red;">{{ (checkNumber.merchant_paid_fee / 100).toFixed(2)
                                    }}</span> 元 </span> -->
                                </li>
                                <li>
                                    <span>应收服务费: <span style="color:red;">{{ (checkNumber.platform_fee / 100).toFixed(2)
                                    }}</span> 元
                                    </span>
                                <!--    <span>待收平台服务费: <span style="color:red;">{{ (checkNumber.platform_wait_fee / 100).toFixed(2)
                                    }}</span> 元 </span>
                                    <span>已收平台服务费: <span style="color:red;">{{ (checkNumber.platform_paid_fee / 100).toFixed(2)
                                    }}</span> 元 </span> -->
                                </li>
                                <li>
                                    <span>应收配送费: <span style="color:red;">{{ (checkNumber.freight_fee / 100).toFixed(2)
                                    }}</span> 元
                                    </span>
                                  <!--  <span>待收配送费: <span style="color:red;">{{ (checkNumber.freight_wait_fee / 100).toFixed(2)
                                    }}</span> 元 </span>
                                    <span>已收配送费: <span style="color:red;">{{ (checkNumber.freight_paid_fee / 100).toFixed(2)
                                    }}</span> 元 </span> -->
                                </li>
                            </ul>
                          </el-row>
                          <el-row :gutter="24">
                               <el-col :span="3">
                                   <el-checkbox v-model="checkedAll" @change="chooseAll" label="选择全部" border></el-checkbox>
                               </el-col>
                               <el-col :span="6">
                                   <div class="block">
                                       <el-date-picker size="mini" v-model="params.times" clearable type="daterange"
                                           :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
                                           end-placeholder="结束日期" align="right">
                                       </el-date-picker>
                                   </div>
                               </el-col>
                               <el-col :span="3">
                                   <el-select v-model="params.belong_billing_date" @change="changeDate" clearable size="mini"
                                       placeholder="归属账期">
                                       <el-option v-for="item in paymentList" :key="item.belong_billing_date"
                                           :label="item.belong_billing_date" :value="item.belong_billing_date">
                                       </el-option>
                                   </el-select>
                               </el-col>
                               <el-col :span="3">
                                   <el-select v-model="params.is_bath" clearable size="mini" placeholder="代付状态">
                                       <el-option v-for="item in isBathArr" :key="item.value" :label="item.label"
                                           :value="item.value">
                                       </el-option>
                                   </el-select>
                               </el-col>
                               <el-col :span="4">
                                   <el-input placeholder="商家id" v-model="params.merchant_id" class="input-with-select"
                                       clearable size="mini">
                                       <el-button slot="append" icon="el-icon-search" @click="searchData">搜索</el-button>
                                   </el-input>
                               </el-col>
                           </el-row>
                          <el-row>
                            <el-dropdown @command="toVerify" v-if="role.verify">
                                <el-button type="danger" size="mini">
                                    批量审核<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="1">通过</el-dropdown-item>
                                    <el-dropdown-item command="2">不通过</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-button size="mini" type="primary" @click="toBatch()" v-if="role.agentpay">一键代付</el-button>
                            <el-button type="primary" @click="getExport()" size="mini">导出数据</el-button>
                            <el-button type="warning" @click="getUpdate()" size="mini">更新账单</el-button>
                            <el-button style="float: right; padding: 3px 0" type="text" onclick="location.reload()">刷新页面 <i class="el-icon-refresh"></i></el-button>
                              <el-button type="warning" size="mini" @click="toUrl('notify')"> 查看ACS明细
                              </el-button>
                            <el-button type="info" @click="getUrl('https://cloud.allinpay.com/ts-cloud-dev-web/#/login')"
                                size="mini">进入通联后台</el-button>
                            <el-button type="info" @click="getUrl('https://vsp.allinpay.com/')" size="mini">进入收银宝
                            </el-button>
                            <el-tooltip content="具体明细请进入通联进行查询" placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                          </el-row>
                      </div>
                </el-card>

                <el-table :data="dataList" :height="wheight - 130" v-loading="loading"
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" align="center" label="全选"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <router-link
                                :to="{ path: 'account_detail', query: { merchant_id: scope.row.merchant_id, belong_billing_date: scope.row.belong_billing_date, account_status: 0 } }">
                                查看明细</router-link>

                        </template>
                    </el-table-column>
                    <el-table-column label="审核&代付状态">
                        <template slot-scope="scope">
                            <el-tag size="mini"
                                :type="scope.row.verify == '0' ? 'warning' : scope.row.verify == '1' ? 'success' : 'info'">
                                {{ scope.row.verify == '0' ? '待审核' : scope.row.verify == '1' ? '已通过' : '未通过' }}
                            </el-tag>
                            <el-tag :type="scope.row.is_bath == 1 ? 'success' : 'info'" size="mini">
                                {{ scope.row.is_bath == 1 ? '已代付' : '未代付' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="比对统计">
                        <template slot-scope="scope">
                            <el-tag type="primary" size="mini">总数:{{ scope.row.order_count }}</el-tag>
                            <el-tag type="success" size="mini">成功:{{ scope.row.order_success_count }}</el-tag>
                            <el-tag type="danger" size="mini">失败:{{ scope.row.order_fail_count }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="merchant_id" label="商家id"></el-table-column>
                    <el-table-column prop="merchant_name" label="商家名称"></el-table-column>
                    <el-table-column prop="belong_billing_date" label="归属账期">
                        <template slot-scope="scope">
                            <small>{{ scope.row.belong_billing_date }}</small>
                        </template>
                    </el-table-column>


                    <el-table-column prop="order_total_fee" label="订单金额">
                        <template slot-scope="scope">
                            {{ (scope.row.order_total_fee / 100).toFixed(2) }}
                        </template>
                    </el-table-column>
                   <!-- <el-table-column prop="order_total_wait_fee" label="订单待付金额">
                        <template slot-scope="scope">
                            {{ (scope.row.order_total_wait_fee / 100).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="order_total_wait_fee" label="订单已付金额">
                        <template slot-scope="scope">
                            {{ (scope.row.order_total_paid_fee / 100).toFixed(2) }}
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="total_fee" label="应付金额">
                        <template slot-scope="scope">
                            {{ (scope.row.total_fee / 100).toFixed(2) }}
                        </template>
                    </el-table-column>

                  <!--  <el-table-column prop="merchant_paid_fee" label="已付金额">
                        <template slot-scope="scope">
                            {{ (scope.row.merchant_paid_fee / 100).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="merchant_wait_fee" label="未付金额">
                        <template slot-scope="scope">
                            {{ (scope.row.merchant_wait_fee / 100).toFixed(2) }}
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="fee" label="应收平台服务费">
                        <template slot-scope="scope">
                            {{ (scope.row.platform_fee / 100).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="platform_paid_fee" label="已收平台服务费">
                        <template slot-scope="scope">
                            {{ (scope.row.platform_paid_fee / 100).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="platform_wait_fee" label="未收平台服务费">
                        <template slot-scope="scope">
                            {{ (scope.row.platform_wait_fee / 100).toFixed(2) }}
                        </template>
                    </el-table-column> -->
                    <el-table-column label="应收配送费">
                        <template slot-scope="scope">
                            {{ (scope.row.freight_fee / 100).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="platform_paid_fee" label="待收配送费">
                        <template slot-scope="scope">
                            {{ (scope.row.freight_wait_fee / 100).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="platform_wait_fee" label="已收配送费">
                        <template slot-scope="scope">
                            {{ (scope.row.freight_paid_fee / 100).toFixed(2) }}
                        </template>
                    </el-table-column> -->
                    <el-table-column label="平台补贴">
                        <template slot-scope="scope">
                            {{ (scope.row.platform_active_fee / 100).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column  label="商家优惠">
                        <template slot-scope="scope">
                            {{ (scope.row.merchant_active_fee / 100).toFixed(2) }}
                        </template>
                    </el-table-column>
                </el-table>
                <div class="content-center content-top-padded">
                    <el-pagination background layout="total, sizes, prev, pager, next"
                        @current-change="handleCurrentChange" @size-change="handleSizeChange"
                        :current-page.sync="params.page" :page-sizes="[20, 50,100,200]" :total="total_count"
                        :page-size="params.pagesize">
                    </el-pagination>
                </div>
            </div>

        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import {
    getPaymentList,
    getBillingTotalList,
    getBillingTotalExportList,
    getBillingDate,
    getBatchAgentPay,
    VerifyTotal,
    getQueryMerchantBalance,
    getQueryReserveFundBalance,
    getQueryVSPFund,
    getChooseAll
} from "../../../api/merchant";
export default {
    components: { draggable },
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            dialogFormVisible: false,
            total_count: 0,
            params: {
                page: 1,
                pagesize: 20,
            },
            dataList: [],
            loading: false,
            id: "",
            ids: '',
            row: [],
            paymentList: [],
            checkArr: '',
            isBathArr: [{ value: 0, label: '未代付' }, { value: 1, label: '已代付' },],
            emptyArr: [{ value: 0, label: '是' }, { value: 1, label: '否' },],
            checkNumber: {
                order_total_fee: 0,
                order_total_wait_fee: 0,
                order_total_paid_fee: 0,
                total_fee: 0,
                merchant_wait_fee: 0,
                merchant_paid_fee: 0,
                platform_fee: 0,
                platform_wait_fee: 0,
                platform_paid_fee: 0,
                freight_fee: 0,
                freight_wait_fee: 0,
                freight_paid_fee: 0,
                accounts_success: 0,
                accounts_fail: 0
            },
            platform: {
              allAmount:0,freezeAmount:0,
              allAmount2:0,freezeAmount2:0,
              allAmount3:0,freezeAmount3:0,
            },
            balance: 0,
            vps: '',
            checkedAll: false,
            role: {},
            params: {
                belong_billing_date: '',
            },
        };
    },
    computed: {
        ...mapGetters(["wheight"]),
    },
    methods: {
        toUrl(url) {
            this.$router.push({
                path: this.matchHidePage(url),
            });
        },
        getInfo(row) {
            this.row = row;

        },

        getPaymentList() {
            getPaymentList({}).then((res) => {
                if (res.data.data) {
                    this.paymentList = res.data.data
                }
            })
        },
        getDataList() {
            this.loading = true;
            getBillingTotalList(this.params)
                .then((response) => {
                    this.dataList = response.data.data.list;
                    this.role = response.data.data.role;
                    this.total_count = response.data.data.total_count;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "获取列表信息出错",
                    });
                });
        },
        handleCurrentChange(page_num) {
            this.params.page = page_num;
            this.getDataList();
        },
        searchData() {
            this.params.page = 1;
            this.getDataList();
        },
        handleSizeChange(pageSize) {
            this.params.page = 1;
            this.params.pagesize = pageSize;
            this.getDataList();
        },
        show(row) {
            //跳转

        },
        //export
        getExport() {
            this.$notify({
                title: '成功',
                message: '正在导出,请稍后...',
                type: 'success'
            })

            getBillingTotalExportList(this.params).then(res => {
                if (res.data.data.status) {
                    this.$notify({
                        title: '成功',
                        message: '已加入队列,请到设置中下载!',
                        type: 'success!'
                    })
                    // var url = res.data.data.url
                    // window.open(url)
                } else {
                    this.$notify({
                        title: '失败',
                        message: '出错了!',
                        type: 'error'
                    })
                }
            })


        },
        getUpdate() {
            getBillingDate({ belong_billing_date: this.params.belong_billing_date }).then(res => {
                this.$message({
                    title: '成功',
                    message: res.data.data.msg,
                    type: 'success'
                })
            })
        },
        handleSelectionChange(val) {
            this.checkedAll = false;
            this.ids = [];
            var checkArr = [];

            var checkNumber =
            {
                order_total_fee: 0,
                order_total_wait_fee: 0,
                order_total_paid_fee: 0,
                total_fee: 0,
                merchant_wait_fee: 0,
                merchant_paid_fee: 0,
                platform_fee: 0,
                platform_wait_fee: 0,
                platform_paid_fee: 0,
                freight_fee: 0,
                freight_wait_fee: 0,
                freight_paid_fee: 0,
                accounts_success: 0,
                accounts_fail: 0
            };
            for (let i in val) {
                checkArr.push(val[i].id)
                checkNumber.order_total_fee += parseInt(val[i].order_total_fee);
                checkNumber.order_total_wait_fee += parseInt(val[i].order_total_wait_fee);
                checkNumber.order_total_paid_fee += parseInt(val[i].order_total_paid_fee);
                checkNumber.total_fee += parseInt(val[i].total_fee);
                checkNumber.merchant_wait_fee += parseInt(val[i].merchant_wait_fee);
                checkNumber.merchant_paid_fee += parseInt(val[i].merchant_paid_fee);
                checkNumber.platform_fee += parseInt(val[i].platform_fee)
                checkNumber.platform_wait_fee += parseInt(val[i].platform_wait_fee)
                checkNumber.platform_paid_fee += parseInt(val[i].platform_paid_fee)
                checkNumber.freight_fee += parseInt(val[i].freight_fee)
                checkNumber.freight_wait_fee += parseInt(val[i].freight_wait_fee)
                checkNumber.freight_paid_fee += parseInt(val[i].freight_paid_fee)
                if (val[i].is_bath == '1') {
                    this.checkNumber.accounts_success += 1;
                }
                if (val[i].is_bath == '0') {
                    this.checkNumber.accounts_fail += 1;
                }
            }
            this.checkArr = checkArr
            //总计
            this.checkNumber = checkNumber;
            this.checkNumber.order_total = checkArr.length;
            console.log(this.checkNumber);
        },
        toVerify(verify) {
            //审核
            var data = {};
            if (this.checkArr.length == 0 && this.params.belong_billing_date.length == '') {
                console.log(this.checkArr.length, '--------', this.params.belong_billing_date);
                this.$message({
                    title: '提示',
                    message: '请选择一个账期或者一条数据!',
                    type: 'error'
                })
                return false;
            } else {
                if (this.checkArr) {
                    data.ids = this.checkArr
                }
                if (this.params.belong_billing_date) {
                    data.belong_billing_date = this.params.belong_billing_date
                }
            }

            var msg = verify == 1 ? '通过' : '不通过';
            this.$prompt('请输入备注!', '批量审核:' + msg, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputErrorMessage: '备注不能为空!'
            }).then(({ value }) => {
                data.verify = verify;
                data.remarks = value;
                VerifyTotal(data).then(res => {
                    this.$notify({
                        title: '提示',
                        message: res.data.data.msg,
                        type: 'success'
                    })
                    setTimeout(() => {
                        this.params.page = 1;
                        this.getDataList();
                    }, 2000)
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });
            });
        },
        toBatch() {
            var data = {};
            if (this.checkArr.length == 0 && this.params.belong_billing_date.length == '') {
                this.$message({
                    title: '提示',
                    message: '请选择一个账期或者一条数据!',
                    type: 'error'
                })
                return false;
            } else {
                if (this.checkArr) {
                    data.ids = this.checkArr
                }
                if (this.params.belong_billing_date) {
                    data.belong_billing_date = this.params.belong_billing_date
                }
            }
            this.$confirm('此操作将进行批量代付, 是否确认继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                getBatchAgentPay(data).then(res => {
                    this.$message({
                        type: 'info',
                        message: res.data.data.msg
                    });
                    if (res.data.data.status == true) {
                        this.$message({
                            type: 'success',
                            message: res.data.data.msg
                        });
                        setTimeout(() => {
                            this.params.page = 1;
                            this.getDataList();
                        }, 2000)
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消代付'
                });
            });

        },
        getMerchantFee() {
            this.platform = {
                allAmount: 0, freezeAmount: 0,
                allAmount2: 0, freezeAmount2: 0,
                allAmount3: 0, freezeAmount3: 0,
            };
            getQueryMerchantBalance({}).then((res) => {
                if (res.data.data.status == true) {
                    var result = res.data.data.data;
                    this.platform.allAmount = result.allAmount
                    this.platform.freezeAmount = result.freezeAmount
                }
            })
            setTimeout(()=>{
              getQueryMerchantBalance({accountSetNo:100004}).then((res) => {
                  if (res.data.data.status == true) {
                      var result = res.data.data.data;
                      this.platform.allAmount2 = result.allAmount
                      this.platform.freezeAmount2 = result.freezeAmount
                  }
              })
            },2000)
              setTimeout(()=>{
              getQueryMerchantBalance({accountSetNo:2000000}).then((res) => {
                  if (res.data.data.status == true) {
                      var result = res.data.data.data;
                      this.platform.allAmount3 = result.allAmount
                      this.platform.freezeAmount3 = result.freezeAmount
                  }
              })
             },2000)
        },
        getQueryReserveFundBalanceData() {
            this.balance = 0;
            getQueryReserveFundBalance({}).then((res) => {
                if (res.data.data.status == true) {
                    this.balance = res.data.data.data.balance
                }
            })
        },
        getQueryVSPFundData() {
            this.vps = {
                balance: 0,
            }
            getQueryVSPFund({}).then((res) => {
                if (res.data.data.status == true) {
                    this.vps = res.data.data.data
                }
            })
        },
        changeDate(val) {
            console.log(val);
            if (val && this.checkedAll) {
                this.chooseAll();
            }
        },
        chooseAll() {
            this.checkNumber = {
                total_fee: 0,
                merchant_wait_fee: 0,
                merchant_paid_fee: 0,
                platform_fee: 0,
                platform_wait_fee: 0,
                platform_paid_fee: 0,
                freight_fee: 0,
                freight_wait_fee: 0,
                freight_paid_fee: 0,
                accounts_success: 0,
                accounts_fail: 0
            }
            if (this.checkedAll) {
                //获取全部商家统计
                getChooseAll(this.params).then((res) => {
                    this.checkNumber = res.data.data
                })
            }
        },
        getUrl(url) {
            window.open(url);
        },

    },
    mounted() {

        this.getDataList();
        this.getPaymentList();
        this.getMerchantFee();
        this.getQueryVSPFundData();
        this.getQueryReserveFundBalanceData();
    },
};
</script>
<style scoped lang="scss">
.el-row {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }

    img {
        width: 90%;
    }
}

.el-col {
    border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// billingtotal.vue?31437847